import { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { ConfirmationDialog, Permitted, ButtonLogs } from 'components'
import { useSnackbar } from 'hooks'
import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'
import { routes } from 'Routes'

const ActionButtons = ({ paymentServiceTemplate, refresh = () => {} }) => {
  const [openChangeStatusDialog, setOpenChangeStatusDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const snackbar = useSnackbar()
  const history = useHistory()

  const handleActiveOrInactive = async () => {
    try {
      await service.dponet.paymentServiceTemplates.update({
        paymentServiceTemplateId: paymentServiceTemplate?.id,
        paymentService: { active: !paymentServiceTemplate?.active },
      })
      snackbar.open({
        message: `Serviço ${
          paymentServiceTemplate?.active ? 'inativado' : 'ativado'
        } com sucesso!`,
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao alterar o status do serviço.',
        variant: 'error',
      })
    }
    setOpenChangeStatusDialog(false)
  }

  const handleDelete = async () => {
    try {
      await service.dponet.paymentServiceTemplates.destroy({
        paymentServiceTemplateId: paymentServiceTemplate?.id,
      })
      snackbar.open({
        message: 'Serviço excluído com sucesso!',
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao excluir o serviço.',
      })
    }
    setOpenDeleteDialog(false)
  }

  const handleChangeStatus = () => setOpenChangeStatusDialog(true)

  return (
    <>
      <ButtonLogs
        entityId={paymentServiceTemplate?.id}
        routes="backoffice/payment_services"
      />
      <Permitted tag={constants.permissions.PAYMENT_SERVICE_TEMPLATES.EDIT}>
        <Button
          fullWidth
          size="small"
          onClick={() =>
            history.push(
              reverse(routes.paymentServiceTemplates.edit, {
                paymentServiceTemplateId: paymentServiceTemplate?.id,
              }),
            )
          }
        >
          Editar
        </Button>
        <Button fullWidth size="small" onClick={handleChangeStatus}>
          {paymentServiceTemplate?.active ? 'Inativar' : 'Ativar'}
        </Button>
      </Permitted>
      <Permitted tag={constants.permissions.PAYMENT_SERVICE_TEMPLATES.DESTROY}>
        <Button
          fullWidth
          size="small"
          onClick={() => setOpenDeleteDialog(true)}
        >
          Excluir
        </Button>
      </Permitted>
      <ConfirmationDialog
        open={openChangeStatusDialog}
        setOpen={setOpenChangeStatusDialog}
        message={
          constants.paymentServiceTemplate.DIALOG_CHANGE_STATUSES[
            paymentServiceTemplate?.active
          ]
        }
        cancelButtonText="Cancelar"
        buttonText={paymentServiceTemplate?.active ? 'Inativar' : 'Ativar'}
        actionAcceptButton={handleActiveOrInactive}
      />
      <ConfirmationDialog
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        message={constants.paymentServiceTemplate.DESTROY_DIALOG}
        cancelButtonText="Cancelar"
        buttonText="Excluir"
        actionAcceptButton={handleDelete}
      />
    </>
  )
}

ActionButtons.propTypes = {
  paymentServiceTemplate: PropTypes.object,
  refresh: PropTypes.func,
}

export default ActionButtons
